import { Query } from '@/types/query';
import { PaginatedResponse, Response } from '@/types/response';
import { CreateUserForm, User } from '@/types/user';
import { api } from '@/utils/axios';

export const UpdateUser = async (data: User): Promise<Response<User>> => {
  const res = await api.put(`/app-web/users/${data.id}`, {
    ...data,
  });
  return res.data;
};

export const ListUsers = async (
  query: Query,
): Promise<PaginatedResponse<User> | Response<User[]>> => {
  const res = await api.get('/app-web/users', {
    params: query,
  });
  return res.data;
};

export const GetUsers = async (
  company_id?: number,
): Promise<Response<User[]>> => {
  const res = await api.get('/app-web/users/all', {
    params: { company_id },
  });
  return res.data;
};

export const CreateUser = async (
  data: CreateUserForm,
): Promise<Response<User>> => {
  const res = await api.post('/app-web/users', data);
  return res.data;
};

export const ShowUser = async (id: number): Promise<Response<User>> => {
  const res = await api.get(`/app-web/users/${id}`);
  return res.data;
};

export const DeleteUserUser = async (id: number): Promise<Response> => {
  const res = await api.delete(`/app-web/users/${id}`);
  return res.data;
};

export const RestoreUser = async (id: number): Promise<Response<User>> => {
  const res = await api.get(`/app-web/users/${id}/restore`);
  return res.data;
};

export const UpdateUserAvatar = async (
  avatar: string,
  userId: number,
): Promise<Response<User>> => {
  const res = await api.put(`/app-web/users/${userId}/avatar`, {
    avatar,
  });
  return res.data;
};

export const DeleteUserAvatar = async (
  userId: number,
): Promise<Response<User>> => {
  const res = await api.delete(`/app-web/users/${userId}/avatar`);
  return res.data;
};

export const FinishOnboarding = async (): Promise<Response<User>> => {
  const res = await api.post('/app-web/users/finish-onboarding');
  return res.data;
};
